// extracted by mini-css-extract-plugin
export var cardWrapper = "_64-0";